// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs-module--tabs--azJCN","tabHeader":"Tabs-module--tabHeader--12nIY","active":"Tabs-module--active--353B_","tabContent":"Tabs-module--tabContent--3xd_K"};